export default __webpack_public_path__ + "static/media/managing-conflict.3f473a98.svg";